import React, { useContext, useState } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { addClientSlice, addClientState } from './AddModalSlice'
import { clientsSlice } from '../ClientsSlice'

// API
import API from '../../../services/api/api'

// Grid system
import { Col, Row } from 'react-grid-system'

// Components
import Modal from '../../../components/Modal/Modal'
import { InputField, NumberField, RadioButton, Textarea } from '../../../components/FormElements/FormElements'
import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader'
import { EmployeesMenu, RolesMenu } from '../../../components/PredefinedMenus/PredefinedMenus'
import { showClientSlice } from '../ShowModal/ShowModalSlice'
import { ConstructionOutlined } from '@mui/icons-material'
import { useNotification } from '../../../services/usenotification'
import SettingContext from '../../../services/context/setting-contentxt/setting-context'
import { useCookies } from 'react-cookie'
import { useAPI } from '../../../services/hoc/useAPI'

export default () => {

    // Translation
    const t = useTranslation()
    const {alertError500}=useNotification()
    // Redux
    const dispatch = useDispatch()
    const state = useSelector((state: { add_client: addClientState }) => state.add_client)
   const {isMobile} =useContext(SettingContext)
 const ENDPOINTS = useAPI()

    // Hooks
    const [showErrors, setShowErrors] = useState<boolean>(false)

    // Add client
    const add = (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault()
        if (
            !state.fields.name ||
            !state.fields.phone ||
            !state.fields.mobile 
           
        ) {
            setShowErrors(true)
            return
        }

        dispatch(addClientSlice.actions.setIsLoading(true))
        const endpoint = state.editId ? ENDPOINTS.clients().update : ENDPOINTS.clients().store
        endpoint({
            id: state.editId,
            ...state.fields,
            debt_ceiling:state.fields.debt_ceiling ?? 0
        })
            .then((response: any) => {
                dispatch(addClientSlice.actions.setIsSuccess(true))
                setTimeout(() => {
                    toggle()
                    dispatch(clientsSlice.actions.addClients([response.data.data]))
                    dispatch(showClientSlice.actions.setIsOpen({ id: response.data.data.id, isOpen: true }))
                }, 1000);
            })
            .catch((err:any)=>{
                alertError500(err)
                dispatch(addClientSlice.actions.setIsLoading(false))
            })

    }

    const toggle = () => {
        dispatch(addClientSlice.actions.setIsOpen(!state.isOpen))
        dispatch(addClientSlice.actions.init())
    }

    return (
        <Modal open={state.isOpen} toggle={toggle}>

            {state.isLoading ? <WhiteboxLoader /> : ""}

            {state.isSuccess ? <SuccessMark /> : ""}

            <h2 className="text-center" style={{ margin: "0 0 20px" }}>{state.editId ? t("edit_client") : t("add_to_clients")}</h2>

            <form onSubmit={add} style={{ width: isMobile?"100vw" :1200, maxWidth: "100%" }}>

                <Row>

                    <Col md={6}>

                        <h3>{t("personal_information")}</h3>

                        <Row>

                            <Col md={6}>
                                <InputField
                                    label={t("name") + " *"}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ name: e.target.value }))}
                                    value={state.fields.name}
                                    error={(showErrors && !state.fields.name) ? t("required_error") : ""} />
                            </Col>

                            <Col md={6}>
                                <InputField
                                    label={t("reference_number") }
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ account_no: e.target.value }))}
                                    value={state.fields.account_no}
                                    error={(showErrors && !state.fields.account_no) ? t("required_error") : ""} />
                            </Col>

                            <Col md={6}>
                                <InputField
                                    label={t("client_number") }
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ serial_no: e.target.value }))}
                                    value={state.fields.serial_no}
                                    error={(showErrors && !state.fields.serial_no) ? t("required_error") : ""} />
                            </Col>

                            <Col md={6}>
                                <InputField
                                    label={t("tax_number") }
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ tax_number: e.target.value }))}
                                    value={state.fields.tax_number}
                                    error={(showErrors && !state.fields.serial_no) ? t("required_error") : ""} />
                            </Col>

                            <Col md={6}>
                                <InputField
                                    label={t("phone_number") + " *"}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ phone: e.target.value }))}
                                    value={state.fields.phone}
                                    error={(showErrors && !state.fields.phone) ? t("required_error") : ""} />
                            </Col>

                            <Col md={6}>
                                <InputField
                                    label={t("fax_number")}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ fax: e.target.value }))}
                                    value={state.fields.fax} />
                            </Col>

                            <Col md={6}>
                                <InputField
                                    label={t("telephone_number") + " *"}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ mobile: e.target.value }))}
                                    value={state.fields.mobile}
                                    error={(showErrors && !state.fields.mobile) ? t("required_error") : ""} />
                            </Col>

                            <Col md={6}>
                                <InputField
                                    type="email"
                                    label={t("email") }
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ email: e.target.value }))}
                                    value={state.fields.email}
                                    error={(showErrors && !state.fields.email) ? t("required_error") : ""} />
                            </Col>

                            <Col md={6}>
                                <InputField
                                    label={t("website")}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                         dispatch(addClientSlice.actions.set({ website: e.target.value }))}
                                    value={state.fields.website}
                                     />
                            </Col>

                            <Col md={6}>
                                <NumberField
                                    label={t("debt_ceiling") }
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ debt_ceiling: Number(e.target.value) }))}
                                    value={state.fields.debt_ceiling}
                                 />
                            </Col>

                            <Col md={6}>
                                <div className="text-left" style={{ margin: "10px 0" }}>
                                    <label>{t("type")}</label><br />
                                    <RadioButton name="type" label={t("post_paid")} checked={state.fields.type === "Post Paid"} onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ type: "Post Paid" }))} />
                                    <span className="margin-20" />
                                    <RadioButton name="type" label={t("cash")} checked={state.fields.type === "Cash"} onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ type: "Cash" }))} />
                                </div>
                            </Col>

                        </Row>

                    </Col>

                    <Col md={6}>

                        <h3>{t("address")}</h3>

                        <Row>

                            <Col md={6}>
                                <InputField
                                    label={t("city")}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ city: e.target.value }))}
                                    value={state.fields.city} />

                                <div className="margin-top-20" />

                                <InputField
                                    label={t("state_or_province") }
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ government: e.target.value }))}
                                    value={state.fields.government}
                                    error={(showErrors && !state.fields.government) ? t("required_error") : ""} />

                                <div className="margin-top-20" />

                                <InputField
                                    label={t("country") }
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ country: e.target.value }))}
                                    value={state.fields.country}
                                    error={(showErrors && !state.fields.country) ? t("required_error") : ""} />

                                <div className="margin-top-20" />

                                <InputField
                                    label={t("zip_or_postal_code")}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ postal_code: e.target.value }))}
                                    value={state.fields.postal_code} />

                                <div className="margin-top-20" />

                                <InputField
                                    label={t("floor_or_house_number")}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ department_number: e.target.value }))}
                                    value={state.fields.department_number} />

                            </Col>

                            <Col md={6}>

                                <Textarea
                                    label={t("address_1") }
                                    rows={3}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ address_1: e.target.value }))}
                                    value={state.fields.address_1}
                                    error={(showErrors && !state.fields.address_1) ? t("required_error") : ""} />

                                <div style={{ marginTop: 15.5 }} />

                                <Textarea
                                    label={t("address_2")}
                                    rows={3}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ address_2: e.target.value }))}
                                    value={state.fields.address_2} />

                                <div style={{ marginTop: 15.5 }} />

                                <Textarea
                                    label={t("address_3")}
                                    rows={3}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addClientSlice.actions.set({ address_3: e.target.value }))}
                                    value={state.fields.address_3} />

                            </Col>

                        </Row>

                    </Col>

                </Row>

                <button className="button round bg-gold color-white margin-top-30"
                 style={{ padding:isMobile?"0 40px" :"0 80px", marginBottom: 5 }}>{t("submit")}</button>

            </form>

        </Modal>
    )

}